@if (initialized) {

  <div class="mx-auto">
    <div class="surface-card border-round-2xl w-full">

      <div class="lg:px-5">
        <div class="flex justify-content-center mb-5">
        <span class="w-6rem h-6rem border-circle flex justify-content-center align-items-center bg-purple-50">
          <i class="pi pi-star text-purple-600 text-5xl"></i>
        </span>
        </div>

        <div class="text-center mb-6">
          <div class="text-color text-3xl font-semibold mb-2">Empfiehl uns weiter</div>
          <span class="text-600 font-medium line-height-3 text-color-secondary">Link kopieren und teilen.</span>
        </div>


        <div class="col-12">
          <div class="grid formgrid p-fluid">
        <span class="p-input-icon-right">
                <i pRipple class="pi pi-copy cursor-pointer" (click)="handleCopyClipboard()"></i>
              <input pInputText [(ngModel)]="referFriendText" [readonly]="true"/>
          </span>
          </div>
        </div>


        <p-divider></p-divider>

        <div class="flex justify-content-center flex-wrap gap-3 mb-4">

          <button (click)="navigateToWhatsApp()" class="p-button p-component p-button-rounded px-0" [ngClass]="{'p-button-text': true}">
            <img src="../../../../assets/images/refer-whatsApp.svg" class="text-5xl text-green-300" alt="WhatsApp">
          </button>

          <button (click)="navigateToTelegram()" class="p-button p-component p-button-rounded px-0" [ngClass]="{'p-button-text': true}">
            <img src="../../../../assets/images/refer-telegram.svg" class="text-5xl text-green-300" alt="Telegram">
          </button>

          <button (click)="navigateToMessenger()" class="p-button p-component p-button-rounded px-0" [ngClass]="{'p-button-text': true}">
            <img src="../../../../assets/images/refer-fb-messenger.svg" class="text-5xl text-green-300" alt="Messenger">
          </button>

          <button (click)="navigateToFacebook()" class="p-button p-component p-button-rounded px-0" [ngClass]="{'p-button-text': true}">
            <img src="../../../../assets/images/refer-facebook.svg" class="text-5xl text-green-300" alt="Facebook">
          </button>

        </div>

      </div>
    </div>
  </div>

}
